import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntersect } from '../utils/hooks';

export const Lazy = ({ children, height, show }) => {
	const [ref, entry] = useIntersect({
		rootMargin: '100px 0px 100px 0px'
	});

	return (
		<div ref={ref} style={{ height }}>
			{entry.isIntersecting || show ? children : null}
		</div>
	);
};

export default Lazy;

Lazy.propTypes = {
	children: PropTypes.element
};
